import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useUpdateClientContactRole } from '~/hooks/reactQuery/queries/useClientContactMutations';
import { useLocaleKeys } from '~/i18n';
import { ROLE_FIELD_NAME, changeContactRoleModalTextsPath } from '../ChangeContactRoleModal.utils';
export const useChangeContactRole = (param)=>{
    let { contact, dismissModal, successToastTestId } = param;
    const { t } = useLocaleKeys(changeContactRoleModalTextsPath);
    const { showSuccessToast } = useOverlayContext();
    const { updateClientContactRole } = useUpdateClientContactRole();
    const [errorMessage, setErrorMessage] = useState(null);
    const changeRole = async (values)=>{
        setErrorMessage(null);
        try {
            await updateClientContactRole({
                clientContactId: contact.id(),
                // WHY: the picker registers `required`, so handleSubmit never reaches here with an unset role
                role: values[ROLE_FIELD_NAME]
            });
        } catch (unused) {
            setErrorMessage(t.saveError());
            return;
        }
        showSuccessToast(t.roleChanged(), successToastTestId);
        dismissModal();
    };
    return {
        errorMessage,
        changeRole
    };
};
